export default __webpack_public_path__ + "static/media/shipbaz.02ab2cb0.svg";